/* 19MW1016: onafhankelijke badge en zoomlabel. */
(() => {
  'use strict';
  const elementName = 'ss-19mw1016-finishing';
  if (customElements.get(elementName)) return;
  class SS19MW1016Finishing extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.choices = [...this.querySelectorAll('[data-finish-field]')];
      try {
        this.priceData = JSON.parse(this.querySelector('[data-ss-19mw1016-option-prices]')?.textContent || '{}');
      } catch { this.priceData = {}; }
      this.addEventListener('change', () => {
        this.dispatchEvent(new CustomEvent('ss:19mw1016:finishing-change', { bubbles: true }));
      }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-finish-info]');
        if (!button) {
          if (!event.target.closest('[data-finish-tooltip]')) this.closeInfo();
          return;
        }
        const wasOpen = this.infoButton === button;
        this.closeInfo();
        if (wasOpen) return;
        this.infoButton = button;
        const tooltip = button.nextElementSibling;
        tooltip.hidden = false;
        button.setAttribute('aria-expanded', 'true');
        const anchor = button.getBoundingClientRect();
        const box = tooltip.getBoundingClientRect();
        tooltip.style.left = `${Math.max(16, Math.min(anchor.right - box.width, window.innerWidth - box.width - 16))}px`;
        tooltip.style.top = `${anchor.top >= box.height + 24 ? anchor.top - box.height - 8 : anchor.bottom + 8}px`;
      }, { signal: this.controller.signal });
      const closeOutside = event => { if (!this.contains(event.target)) this.closeInfo(); };
      document.addEventListener('click', closeOutside, { signal: this.controller.signal });
      document.addEventListener('focusin', closeOutside, { signal: this.controller.signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.infoButton) {
          const button = this.infoButton;
          this.closeInfo();
          button.focus();
        }
      }, { signal: this.controller.signal });
      window.addEventListener('resize', () => this.closeInfo(), { signal: this.controller.signal });
      window.addEventListener('scroll', () => this.closeInfo(), { signal: this.controller.signal, capture: true });
    }
    closeInfo() {
      if (!this.infoButton) return;
      this.infoButton.setAttribute('aria-expanded', 'false');
      this.infoButton.nextElementSibling.hidden = true;
      this.infoButton = null;
    }
    disconnectedCallback() {
      this.closeInfo();
      this.controller?.abort();
      this.controller = null;
    }
    getSelection() {
      return {
        badge: this.choices.find(input => input.dataset.finishField === 'badge' && input.checked)?.value || 'none',
        hemLabel: this.choices.find(input => input.dataset.finishField === 'hemLabel' && input.checked)?.value || 'none'
      };
    }
    getProperties() {
      const label = field => this.choices.find(input => input.dataset.finishField === field && input.checked)?.dataset.optionLabel || 'Geen';
      return {
        'Opgestikte logobadge': label('badge'),
        'Zoomlabel': label('hemLabel')
      };
    }
    getSummary() {
      return Object.entries(this.getProperties()).map(([label, value]) => `${label}: ${value}`).join('; ');
    }
    getPricing(quantity, selection = this.getSelection()) {
      const skus = {
        sublimated: '19MW1016-OPT-SUBLIMATED', 'woven-label': '19MW1016-OPT-WOVEN-LABEL',
        'woven-badge': '19MW1016-OPT-WOVEN-BADGE', 'brown-pu': '19MW1016-OPT-BROWN-PU',
        'black-pu': '19MW1016-OPT-BLACK-PU', 'woven-2-4': '19MW1016-OPT-WOVEN-2-4',
        'fast-shipping': '19MW1016-OPT-FAST-SHIPPING'
      };
      const selected = Object.values(selection).filter(value => value !== 'none');
      const lines = [];
      const tiers = Array.isArray(this.priceData?.tiers) ? this.priceData.tiers : [];
      const firstValues = Array.isArray(tiers[0]?.variant_values) ? tiers[0].variant_values : [];
      const idOf = value => String(value || '').split('/').pop();
      const cents = value => value === null || value === undefined || value === '' ? null
        : Number.isFinite(Number(value)) ? Math.round(Number(value) * 100) : null;
      for (const choice of selected) {
        // Onder 1.000 is zes dagen transport inbegrepen: nooit een betaalregel.
        if (choice === 'fast-shipping' && quantity < 1000) continue;
        const saved = firstValues.find(value => value.sku === skus[choice]);
        const id = idOf(saved?.variant_id);
        const variant = this.priceData?.variants?.find(value => idOf(value.id) === id);
        const baseCents = cents(variant?.base ?? saved?.basis_price);
        const eligible = tiers.filter(row => Number(row.min) > 0 && Number(row.min) <= quantity);
        const prices = eligible.map(row => row.variant_values?.find(value => idOf(value.variant_id) === id))
          .map(value => cents(value?.value));
        if (!skus[choice] || !id || baseCents === null || baseCents <= 0 || !prices.length || prices.some(value => value === null || value <= 0)) {
          return { lines: [], unitCents: 0, error: choice === 'fast-shipping'
            ? 'De prijs voor snelle verzending is nog niet beschikbaar. Kies standaard verzending of neem contact met ons op.'
            : 'De prijs van deze afwerking is nog niet beschikbaar. Kies een andere afwerking of neem contact met ons op.' };
        }
        lines.push({ id, sku: saved.sku, title: saved.title, unitCents: Math.min(baseCents, ...prices), available: variant?.available === true });
      }
      return { lines, unitCents: lines.reduce((sum, line) => sum + line.unitCents, 0), error: '' };
    }
    restore(selection = {}) {
      if (!selection || typeof selection !== 'object') selection = {};
      for (const field of ['badge', 'hemLabel']) {
        const options = this.choices.filter(input => input.dataset.finishField === field);
        const value = options.some(input => input.value === selection[field]) ? selection[field] : 'none';
        options.forEach(input => { input.checked = input.value === value; });
      }
    }
  }
  customElements.define(elementName, SS19MW1016Finishing);
})();
